import { observable } from "mobx";
export class LogStore {
    @observable
    public selectedDate: number = new Date().getDate();
}

export const logStore = new LogStore();


// WEBPACK FOOTER //
// ./src/models/LogStore.ts